var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThermostat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_5476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6001 13V5C15.6001 3.34 14.2601 2 12.6001 2C10.9401 2 9.6001 3.34 9.6001 5V13C8.3901 13.91 7.6001 15.37 7.6001 17C7.6001 19.76 9.8401 22 12.6001 22C15.3601 22 17.6001 19.76 17.6001 17C17.6001 15.37 16.8101 13.91 15.6001 13ZM11.6001 11V5C11.6001 4.45 12.0501 4 12.6001 4C13.1501 4 13.6001 4.45 13.6001 5V6H12.6001V7H13.6001V8V9H12.6001V10H13.6001V11H11.6001Z",
    fill: "#28B178"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_5476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.600098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermostat);
export default __webpack_public_path__ + "static/media/thermostat.cffcdeb57c69ef1c857d0a100f5e3c06.svg";
export { ForwardRef as ReactComponent };